const translations = {
  en: {

    // Sign In Page

    signIn: "Sign In",
    subtitle: "Use your email and password",
    username: "Username",
    password: "Password",
    login: "Login",
    logging: "Logging in...",

    title: "Nanbarul Pawn Shop - Admin",
    loginDesc: "Admin Login Portal",
    manageText: "Manage data and users",

    userRequired: "Username is required",
    passRequired: "Password is required",
    selectLang: "Select Language",

    // Sidebar & Dashboard

    dashboard: "Dashboard",
    customers: "Customer List",
    settings: "Profile Settings",
    Collection :"Collections",
    reports : "Reports",

    // Customer Details List Page

    customerList: "Customer Details List",
    searchPlaceholder: "Search customers loan id & name ...",
    customerLogin: "Customer Login",

    slNo: "Sl No",
    loanId: "Loan Id",
    name: "Name",
    date: "Date",
    loanAmount: "Loan Amount",
    interest: "Interest (%)",
    remaining: "Remaining Amount",
    status: "Status",
    actions: "Actions",
    active: "Active",
    closedTable: "Closed",
    noRecords: "No records found",
    showing: "Showing",
    of: "of",

    confirmDelete: "Confirm Delete",
    deleteMessage: "Are you sure you want to delete this customer",
    yesDelete: "Yes, Delete",
    cancel: "Cancel",

    loginOptions: "Login Options",
    selectCustomerType: "Select a customer type:",
    newCustomer: "New Customer",
    existingCustomer: "Existing Customer",
    existingLogin: "Existing Customer Login",
    phoneNumber: "Phone Number",
    enterPhone: "Enter phone number",
    login: "Login",
    phoneRequired: "Phone number is required",
    phoneInvalid: "Phone number must be 10 digits",
    phoneStart: "Phone number should start with 6–9",

    customer: "Customer",
    create: "Create",
    edit: "Edit",
    back: "Back",

     name: "Name",
    guardianName: "Guardian Name",
    phone: "Phone No",
    altPhone: "Alternate Phone No",
    address: "Address",
    loanDetails: "Loan Details",
    loanDate: "Loan Start Date",
    loanAmount: "Loan Amount",
    interest: "Interest Rate",
    livePic: "Live Pic",
    upload: "Upload",
    capture: "Capture",
    submit: "Submit",
    closed: "This loan is closed",
    interestRate: "Interest Rate (%)",
    selectRate: "Select Rate",
    interestReq: "Interest is required",

    durationType: "Duration Type",
    selectDuration: "Select Duration",
    months: "Months",

    interestAmount: "Interest Amount",
    totalAmount: "Total Amount",

    aadhar: "Aadhar No",
    aadharReq: "Aadhar number is required",
    aadharInvalid: "Enter a valid 12-digit Aadhar number",

    aadharPhoto: "Aadhar Card Photo",
    jewelName: "Jewel Name",
    jewelNameReq: "Jewel name is required",

    jewelWeight: "Jewel Weight",
    jewelLessWeight: "Jewel Less Weight",
    jewelLessWeightReq: "Jewel Less weight is required",

    jewelAmount: "Jewel Amount",
    jewelPic: "Jewel Pic",
    optionalPic: "Pic (opt)",

    noImage: "No Image",
    gram: "gram",

    // errors
    nameReq: "Name is required",
    phoneReq: "Phone number is required",
    phoneInvalid: "Enter a valid 10-digit phone number",
    phoneStart: "Phone number should start with 6–9",
    addressReq: "Address is required",
    loanReq: "Loan amount is required",
    dateReq: "Date is required",

    // Setting Page

    profileSettings: "Profile Settings",
    back: "Back",
    userName: "User Name",
    phone: "Phone No",
    image: "Image",
    oldPassword: "Old Password",
    newPassword: "New Password",
    submit: "Submit",
    updating: "Updating...",

    // Dashboard Page

    allRecords: "All Records",

    // Collection Page



    //Customer View Page
    customerView: "Customer View",


    // Customer Pay Page
    customerPay: "Customer Pay",
  },

  ta: {

     // Sign In Page

    signIn: "உள்நுழை",
    subtitle: "உங்கள் மின்னஞ்சல் மற்றும் கடவுச்சொல்லைப் பயன்படுத்தவும்",
    username: "பயனர் பெயர்",
    password: "கடவுச்சொல்",
    login: "உள்நுழை",
    logging: "உள்நுழைகிறது...",

    title: "நண்பருள் அடகு கடை - நிர்வாகம்",
    loginDesc: "நிர்வாகப் பயன்பாட்டிற்கான உள்நுழைவு",
    manageText: "தகவல்கள் மற்றும் பயனர்களை நிர்வகிக்கவும்",

    userRequired: "பயனர் பெயர் தேவை",
    passRequired: "கடவுச்சொல் தேவை",
    selectLang: "மொழியைத் தேர்ந்தெடுக்கவும்",

     // Sidebar & Dashboard

    dashboard: "டாஷ்போர்ட்",
    customers: "வாடிக்கையாளர் பட்டியல்",
    settings: "அமைப்புகள்",
  Collection :"வசூல்கள்",
reports : "அறிக்கைகள்" ,

    // Customer Details List Page

    customerList: "வாடிக்கையாளர் விவர பட்டியல்",
    searchPlaceholder: "கடன் ஐடி & பெயர் மூலம் தேடவும்...",
    customerLogin: "வாடிக்கையாளர் உள்நுழைவு",

    slNo: "வரிசை எண்",
    loanId: "கடன் ஐடி",
    name: "பெயர்",
    date: "தேதி",
    loanAmount: "கடன் தொகை",
    interest: "வட்டி (%)",
    remaining: "மீதமுள்ள தொகை",
    status: "நிலை",
    actions: "செயல்கள்",
    active: "செயலில்",
    closedTable: "மூடப்பட்டது",
    noRecords: "பதிவுகள் இல்லை",
    showing: "காண்பிப்பு",
    of: "இல்",

    confirmDelete: "நீக்கம் உறுதிப்படுத்தவும்",
    deleteMessage: "இந்த வாடிக்கையாளரை நீக்க விரும்புகிறீர்களா",
    yesDelete: "ஆம், நீக்கு",
    cancel: "ரத்து",

    loginOptions: "உள்நுழைவு விருப்பங்கள்",
    selectCustomerType: "வாடிக்கையாளர் வகையை தேர்ந்தெடுக்கவும்:",
    newCustomer: "புதிய வாடிக்கையாளர்",
    existingCustomer: "இருக்கும் வாடிக்கையாளர்",

    existingLogin: "இருக்கும் வாடிக்கையாளர் உள்நுழைவு",
    phoneNumber: "தொலைபேசி எண்",
    enterPhone: "தொலைபேசி எண்ணை உள்ளிடவும்",
    login: "உள்நுழை",
    phoneRequired: "தொலைபேசி எண் தேவை",
    phoneInvalid: "10 இலக்க தொலைபேசி எண் வேண்டும்",
    phoneStart: "6 முதல் 9 வரை தொடங்க வேண்டும்",

    customer: "வாடிக்கையாளர்",
    create: "உருவாக்கு",
    edit: "திருத்து",
    back: "பின்",

    name: "பெயர்",
    guardianName: "காவலர் பெயர்",
    phone: "தொலைபேசி எண்",
    altPhone: "மாற்று தொலைபேசி எண்",
    address: "முகவரி",
    livePic: "நேரடி படம்",
    upload: "பதிவேற்று",
    capture: "பிடி",
    loanDetails: "கடன் விவரங்கள்",
    loanDate: "கடன் தொடக்க தேதி",
    loanAmount: "கடன் தொகை",
    interest: "வட்டி விகிதம்",
    submit: "சமர்ப்பிக்கவும்",
    closed: "இந்த கடன் முடிக்கப்பட்டது",
    interestRate: "வட்டி விகிதம் (%)",
    selectRate: "விகிதத்தை தேர்ந்தெடுக்கவும்",
    interestReq: "வட்டி தேவை",

    durationType: "கால அளவு",
    selectDuration: "காலத்தை தேர்ந்தெடுக்கவும்",
    months: "மாதங்கள்",

    interestAmount: "வட்டி தொகை",
    totalAmount: "மொத்த தொகை",

    aadhar: "ஆதார் எண்",
    aadharReq: "ஆதார் எண் தேவை",
    aadharInvalid: "சரியான 12 இலக்க ஆதார் எண் உள்ளிடவும்",

    aadharPhoto: "ஆதார் அட்டை படம்",
    jewelName: "நகை பெயர்",
    jewelNameReq: "நகை பெயர் தேவை",

    jewelWeight: "நகை எடை",
    jewelLessWeight: "நகை குறைந்த எடை",
    jewelLessWeightReq: "நகை எடை தேவை",

    jewelAmount: "நகை தொகை",
    jewelPic: "நகை படம்",
    optionalPic: "விருப்ப படம்",

    noImage: "படம் இல்லை",
    gram: "கிராம்",

    // errors
    nameReq: "பெயர் தேவை",
    phoneReq: "தொலைபேசி எண் தேவை",
    phoneInvalid: "சரியான 10 இலக்க எண் உள்ளிடவும்",
    phoneStart: "6 முதல் 9 வரை தொடங்க வேண்டும்",
    addressReq: "முகவரி தேவை",
    loanReq: "கடன் தொகை தேவை",
    dateReq: "தேதி தேவை",

    // Setting Page

    profileSettings: "சுயவிவர அமைப்புகள்",
    back: "பின்",
     userName: "பயனர் பெயர்",
    phone: "தொலைபேசி எண்",
    image: "படம்",
    oldPassword: "பழைய கடவுச்சொல்",
    newPassword: "புதிய கடவுச்சொல்",
    submit: "சமர்ப்பிக்கவும்",
    updating: "புதுப்பிக்கிறது...",

    // Dashboard Page
    allRecords: "அனைத்து பதிவுகளின் பட்டியல்",

    // Customer View Page
    customerView: "வாடிக்கையாளர் விவரம்",

    // Customer Pay Page
   customerPay: "கட்டணம் செலுத்துதல்",
  }
};

export default translations;